import React from 'react';
import './FormFieldsStyle.css';
import chatPerson from "../../images/img/chat-person.png"
//import videoPlayerImg from "../../images/img/pack-detaill.png"



const Video = (props) => {
    
    const data = props.item && props.item.data && JSON.parse(props.item.data)
    console.log("videoprops",props,data,props.item.url)

 return(
        <div className="mB10">
            <div style={{display:'flex'}}>
       <div className="chat-person" style={{ marginTop: '10px'}}>
                <img src={chatPerson} alt="" /> </div>
            <div className="chat-text" style={{ margin: '10px 0px' }} >
                {props.item.text}  </div> </div>
            {/* <video width={data.width} height={data.height} controls="controls" style={{ margin: '10px 0px 10px 40px' }}>
             <source src={props.item.url}  type="video/webm"/>

         </video> */}
         <iframe width={data.width} height={data.height} src={props.item.url} frameborder="0" gesture="media" allow="autoplay; encrypted-media" allowfullscreen style={{ margin: '10px 0px 10px 40px' }}> </iframe>
            {/* <img src={videoPlayerImg} alt="" class="img-fluid" /> */}
            </div>
    )
}


export default Video;